import Skeleton from "@/components/Atoms/Skeleton";
import {
  type breakpointDimensions,
  StyledSkeletonHomeCard,
  StyledSkeletonHomeWrapper,
  StyledSkeletonProductContainer,
  StyledSkeletonSearchAndFilterGallery,
} from "./styles";
import Card from "@/components/Atoms/Card";
import ProductGallerySkeleton from "@components/Atoms/ProductCardGallerySkeleton";
import { theme } from "twin.macro";
import { FlowboxType, type FlowboxProps } from "@components/Molecules/Flowbox";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { useMemo } from "react";

interface FlowboxSkeletonProps {
  type: FlowboxProps["type"];
}
const FlowboxSkeleton = ({ type }: FlowboxSkeletonProps) => {
  const is503PX = useMediaQuery("(min-width: 503px)");
  const is973PX = useMediaQuery("(min-width: 973px)");
  const is1208PX = useMediaQuery("(min-width: 1208px)");

  const skeletonSize = useMemo(() => {
    let length = 6;
    let screenSize: breakpointDimensions;

    if (is1208PX) {
      length = 15;
      screenSize = "1208PX";
    } else if (is973PX) {
      length = 12;
      screenSize = "973PX";
    } else if (is503PX) {
      length = 9;
      screenSize = "503PX";
    }

    return { length, screenSize };
  }, [is503PX, is973PX, is1208PX]);

  return (
    <>
      {type === FlowboxType.PRODUCT && (
        <Card>
          <StyledSkeletonProductContainer>
            <div className="head">
              <Skeleton
                type="text"
                width="10rem"
                height="1.5rem"
                borderRadius="0.5rem"
                backgroud={theme`colors.primaryV2.60`}
                animate
              />
            </div>
            <div className="wrapper">
              {Array.from({ length: 7 }).map((_, index) => (
                <article tw="flex-1" key={index.toString()}>
                  <ProductGallerySkeleton sizeVariant="sm" orientation={"horizontal"} />
                </article>
              ))}
            </div>
          </StyledSkeletonProductContainer>
        </Card>
      )}

      {type === FlowboxType.HOME && (
        <div tw="animate-pulse1">
          <Skeleton type="text" height="1.25rem" width="40%" />
          <Skeleton type="text" height="1.25rem" width="70%" tw="mt-2.5 mb-5" />
          <StyledSkeletonHomeWrapper $screenSizeQuery={skeletonSize.screenSize}>
            {Array.from({ length: skeletonSize.length }).map((_, index) => (
              <StyledSkeletonHomeCard
                key={index}
                $isLargeCard={index === 3}
                $screenSizeQuery={skeletonSize.screenSize}
              >
                <Skeleton type="gallery" height="100%" tw="box-border" />
              </StyledSkeletonHomeCard>
            ))}
          </StyledSkeletonHomeWrapper>
        </div>
      )}

      {/* Prox usar el siguiente código para el skeleton flowbox SEARCH_AND_FILTER */}

      {/* {type === FlowboxType.SEARCH_AND_FILTER && (
        <Skeleton type="card" height="auto">
          <div tw="p-m">
            <Skeleton
              type="text"
              height="1rem"
              width="36%"
              tw=" mb-m medium:(h-[1.125rem]) large:(h-[1.25rem])"
            />
            <Skeleton type="text" height="1.75rem" width="60%" tw="medium:(h-[0.875rem]) " />
          </div>
          <StyledSkeletonSearchAndFilterGallery>
            {Array.from({ length: is503PX ? 4 : 3 }).map((_, index) => (
              <article tw="flex-1" key={index}>
                <Skeleton
                  type="image"
                  height="7.625rem"
                  tw="medium:(h-[12.188rem] large:(h-[17.438rem])) rounded-s"
                />
              </article>
            ))}
          </StyledSkeletonSearchAndFilterGallery>
        </Skeleton>
      )} */}
      {type === FlowboxType.HOME_CAROUSEL && (
        <div tw="h-[14.813rem] medium:h-[12.938rem] large:h-[17.25rem] w-full"></div>
      )}
    </>
  );
};

export default FlowboxSkeleton;
